import router from '@/router'

// State mặc định
const state = {
  snackbar: {
    show: false,
    message: '',
    color: 'success',
    timeout: 3000
  },
  loading: false,
  errors: []
}

// Getters
const getters = {
  isLoading: state => state.loading,
  hasErrors: state => state.errors.length > 0
}

// Mutations
const mutations = {
  SET_LOADING(state, status) {
    state.loading = status
  },
  SHOW_SNACKBAR(state, { message, color = 'success', timeout = 3000 }) {
    state.snackbar = {
      show: true,
      message,
      color,
      timeout
    }
  },
  HIDE_SNACKBAR(state) {
    state.snackbar.show = false
  },
  ADD_ERROR(state, error) {
    state.errors.push(error)
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  }
}

// Actions
const actions = {
  setLoading({ commit }, status) {
    commit('SET_LOADING', status)
  },

  showSuccess({ commit }, message) {
    commit('SHOW_SNACKBAR', {
      message,
      color: 'success'
    })
  },

  showError({ commit }, message) {
    commit('SHOW_SNACKBAR', {
      message,
      color: 'error'
    })
  },

  showWarning({ commit }, message) {
    commit('SHOW_SNACKBAR', {
      message,
      color: 'warning'
    })
  },

  hideSnackbar({ commit }) {
    commit('HIDE_SNACKBAR')
  },

  addError({ commit }, error) {
    commit('ADD_ERROR', error)
  },

  clearErrors({ commit }) {
    commit('CLEAR_ERRORS')
  },

  // Xử lý lỗi chung cho toàn ứng dụng
  handleError({ dispatch }, error) {
    console.error('Application Error:', error)

    let message = 'Đã xảy ra lỗi, vui lòng thử lại sau.'

    if (error.response) {
      // Lỗi từ server
      const status = error.response.status
      const data = error.response.data

      switch (status) {
        case 400:
          message = data.message || 'Yêu cầu không hợp lệ'
          break
        case 401:
          message = 'Phiên làm việc đã hết hạn'
          // Xóa token và chuyển hướng về trang đăng nhập
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          router.push('/login')
          break
        case 403:
          message = 'Bạn không có quyền thực hiện thao tác này'
          break
        case 404:
          message = 'Không tìm thấy dữ liệu yêu cầu'
          break
        case 422:
          message = data.message || 'Dữ liệu không hợp lệ'
          break
        case 500:
          message = 'Lỗi hệ thống, vui lòng thử lại sau'
          break
        default:
          message = data.message || message
      }
    } else if (error.request) {
      // Lỗi kết nối
      message = 'Không thể kết nối đến máy chủ'
    }

    dispatch('showError', message)
    dispatch('addError', {
      timestamp: new Date(),
      message,
      error: error
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}